import React from 'react';
import { connect } from "react-redux";
import { Form, Col, Card, Table, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { withStyles } from '@material-ui/core/styles/';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import CrudActions from '../../../../partials/datatable/CrudActions';
import IsValidName from '../../../../utils/validators/IsValidName';
import { QuizApiService } from '../../../../services/Ananse/QuizApiService';
import Loading from '../../../home/components/Loading';
import { withRouter, Link } from 'react-router-dom';
import withFormValidation from '../../../../hoc/withFormValidation';
import Select from 'react-select';
import { IconButton, RadioGroup, FormControlLabel, Radio, colors } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import SelectSearchComponent from '../../../auth/Components/Select2';
import { QuestionApiService } from '../../../../services/Ananse/QuestionApiService';
import DatatableStandalone from '../../../../partials/datatable/DatatableStandalone';
import { FormattedMessage } from 'react-intl';
import translate from '@noar-basf/commons';
// import SortableTree from 'react-sortable-tree';
import ConfirmDeleteDialog from '../../../../partials/datatable/ConfirmDeleteDialog';
import 'react-sortable-tree/style.css';

const BrownRadio = withStyles({
  root: {
    color: colors.brown[400],
    '&$checked': {
      color: colors.brown[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const initialQuestion = {
  quizQuestionId: null,
  questionId: null,
  quest: '',
  answers: []
};

const initialAnswer = {
  quizQuestionAnswerId: null,
  answerId: null,
  desc: '',
  description: '',
  isAnswerFinish: false,
  nextQuizQuestionId: null,
  nextQuizQuestion: null,
  fragrances: []
};

const initialState = {
  quizName: '',
  quizId: null,
  validatedAt: null,
  publishedAt: null,
  campaignId: null,
  campaignName: '',
  language: '',
  questions: [],
  fragrancesSelected: [],
  collection: [],
  loading: false,
  question: { ...initialQuestion },
  answer: { ...initialAnswer },
  answerSelectedIndex: null,
  requiredQuestion: false,
  requiredAnswer: false,
  requiredAnswers: false,
  requiredNextQuestion: false,
  requiredFragrance: false
}

class QuizUpdate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
      confirmDelete: false,
      id: null,
      treeData: []
    };

    this.api = new QuizApiService();
    this.questionApi = new QuestionApiService();

    this.translate = this.props.translate;
    this.handleChange = this.handleChange.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.handleQuestion = this.handleQuestion.bind(this);
    this.handleAnswer = this.handleAnswer.bind(this);
    this.handleSelectFragranceAnswer = this.handleSelectFragranceAnswer.bind(this);
    this.handleSelectNextQuestion = this.handleSelectNextQuestion.bind(this);
    this.addAnswer = this.addAnswer.bind(this);
    this.clearAnswer = this.clearAnswer.bind(this);
    this.editAnswer = this.editAnswer.bind(this);
    this.createQuestion = this.createQuestion.bind(this);
    this.onCleanForm = this.onCleanForm.bind(this);
    this.onConfirmDelete = this.onConfirmDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.validateQuiz = this.validateQuiz.bind(this);
    this.publishQuiz = this.publishQuiz.bind(this);
  }

  async getQuiz(id) {
    const quiz = await this.api.get(id);

    if (quiz) {
      this.setState({
        loading: false,
        quizId: quiz.quizId,
        validatedAt: quiz.validatedAt,
        publishedAt: quiz.publishedAt,
        quizName: quiz.name,
        campaignId: quiz.campaignId,
        campaignName: quiz.campaign?.name,
        collection: quiz.campaign?.collection,
        questions: quiz.questions,
        language: quiz.language,
        question: {
          quizQuestionId: null,
          questionId: null,
          quest: '',
          answers: []
        },
        answer: { ...initialAnswer }
        // treeData: await this.formatTreeData(quiz)
      });
      return quiz;
    } else {
      this.props.history.push('/admin/quiz');
    }
  }

  async formatTreeData(quiz) {
      let { questions } = quiz;

      const typeQuestion = 'question';
      const typeAnswer = 'answer';
      const typeFragrance = 'fragrance';

      if (!questions.length > 0) {
        return [];
      }

      questions = questions.reverse();

      let questionsFormat = questions.map(q => {
        const { question, answers, questionId, quizQuestionId, quizId } = q;

        return {
          title: (
            <>
              <div
                style={{
                  backgroundColor: "#6E5221",
                  display: "inline-block",
                  borderRadius: 5,
                  color: "#FFF",
                  padding: "0 5px",
                  marginRight: "0.3rem"
                }}
              >
                Question
              </div>
              { question.quest }
            </>
          ),
          answers,
          question,
          questionId,
          quizQuestionId,
          quizId,
          expanded: true,
          nodeType: typeQuestion,
          children: answers.map(ans => {

              const { answer, fragranceOptions, quizQuestionAnswerId } = ans;
              // Run some code
              return {
                title: (
                  <>
                    <div
                      style={{
                        backgroundColor: "#0D2551",
                        display: "inline-block",
                        borderRadius: 5,
                        color: "#FFF",
                        padding: "0 5px",
                        marginRight: "0.3rem"
                      }}
                    >
                      Answer
                    </div>
                    { answer.label }
                  </>
                ),
                nextId: ans.nextQuestion?.question?.questionId,
                quizQuestionAnswerId,
                nodeType: typeAnswer,
                expanded: true,
                children: fragranceOptions.length > 0
                  ? fragranceOptions.map(frag => {
                    const { fragrance, fragranceOptionId } = frag;
                    return {
                      title: (
                      <>
                        <div
                          style={{
                            backgroundColor: "#0abb87",
                            display: "inline-block",
                            borderRadius: 5,
                            color: "#FFF",
                            padding: "0 5px",
                            marginRight: "0.3rem"
                          }}
                        >
                          Fragrance
                        </div>
                        { fragrance.name }
                      </>
                      ),
                      children: [],
                      nodeType: typeFragrance,
                      fragranceOptionId,
                      noDragging: false,
                      noChildren: true,
                    }
                  })
                  : []
              }

          })
        }
      });
      // setTimeout(() => {
      let response = await this.questionsFormated(questionsFormat);
      return response;

      // let teste = await
      //   console.log(teste);


        // console.log(teste);
        // this.setState({ treeData: [questionsFormat[questionsFormat.length -1]] });
        // resolve([questionsFormat[questionsFormat.length -1]]);
        // return [questionsFormat[questionsFormat.length -1]];
      // }, 1000);
    // console.log(questionsFormat.reverse());

  }

  questionsFormated(questionsFormat) {
    return new Promise(function(resolve, reject) {
      setTimeout(() => {
        questionsFormat.reverse().forEach(qf => {
          const { questionId } = qf;
          questionsFormat.forEach(q => {
            // console.log(q);
            let { children } = q;
            let childrenFound = children.filter(c => c.nextId === questionId);

            // setTimeout(() => {
              if (childrenFound.length > 0) {
                  // Run some code
                  childrenFound.forEach(cf => {
                    cf.children = [qf];
                  });
              }
            // }, 500);
          });

        });
        resolve([questionsFormat[questionsFormat.length -1]]);
      }, 3000);
    });
  }

  onCleanForm() {
    this.setState({
      loading: false,
      question: {
        quizQuestionId: null,
        questionId: null,
        quest: '',
        answers: []
      },
      answer: {
        quizQuestionAnswerId: null,
        answerId: null,
        desc: '',
        description: '',
        isAnswerFinish: false,
        nextQuizQuestionId: null,
        nextQuizQuestion: null,
        fragrances: []
      }
    });
  }

  async componentDidMount() {
    const id = this.props.match.params.id;
    if (!id) {
      return;
    }

    this.setState({ loading: true });

    try {
      let quiz = await this.getQuiz(id);
      let treeData = await this.formatTreeData(quiz);

      console.log(quiz);
      console.log(treeData);

      this.setState({ treeData });
    } catch (error) {
      this.setState({ loading: false });
      Swal.fire(
        this.translate.screens.quiz.errors.title,
        this.translate.screens.quiz.errors.message,
        'error'
      );
    }
  }

  createQuestion = async (e) => {
    e.preventDefault();
    try {
      const reqBase = { method: 'POST', url: 'add-update' };

      const { quizId, question } = this.state;

      let hasError = false;
      if (!question || (!question.questionId && !question.quest)) {
        this.setState({ requiredQuestion: true });
        hasError = true;
      }

      if (question.answers?.length === 0) {
        this.setState({ requiredAnswers: true });
        hasError = true;
      }

      if (hasError) {
        return;
      }

      this.setState({ loading: true });

      question.quizId = quizId;
      await this.questionApi.makeHttpRequest({
        ...reqBase,
        data: question
      });

      await this.getQuiz(quizId);
      Swal.fire({
        title: translate(this.props.i18n.lang).defaultMessages?.success,
        text: this.translate.screens.quiz.messages?.add,
        icon: 'success',
        cancelButtonText: translate(this.props.i18n.lang).buttons?.cancel,
      });
    } catch (e) {
      this.setState({ loading: false });
      Swal.fire(
        'ERROR',
        e.response && e.response.status === 400
          ? e.response.data
          : this.translate.screens.quiz.errors.createQuestion,
        'error'
      );
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleChangeAnswerDesc = (e) => {
    const { answer } = this.state;
    answer.description = e.target.value;
    this.setState({
      answer
    });
  }

  handleRadio = (e) => {
    const { answer } = this.state;
    answer.isAnswerFinish = e.target.value === 'true';
    this.setState({
      answer
    });
  }

  handleQuestion = obj => {
    const { question } = this.state;
    question.questionId = obj.id;
    question.quest = obj.label.replace(this.translate.screens.quiz.placeholders?.newQuestion, '');
    this.setState({ question: { ...question }, requiredQuestion: false });
  }

  handleAnswer = obj => {
    console.log(obj);
    const { answer } = this.state;

    answer.answerId = obj.id;
    answer.desc = obj.label.replace(this.translate.screens.quiz.placeholders?.newAnswer, '');
    answer.description = obj.description ?? '';

    this.setState({ answer, requiredAnswer: false });
  }

  handleSelectFragranceAnswer = obj => {
    const { answer } = this.state;
    answer.fragrances = obj;
    this.setState({ answer, requiredFragrance: false });
  }

  handleSelectNextQuestion = obj => {
    const { answer } = this.state;
    answer.nextQuizQuestionId = obj.value;
    answer.nextQuizQuestion = obj;
    this.setState({ answer, requiredNextQuestion: false });
  }

  addAnswer = () => {
    const { question, answer, answerSelectedIndex } = this.state;

    let hasError = false;
      if (!answer || (!answer.answerId && !answer.desc)) {
        this.setState({ requiredAnswer: true });
        hasError = true;
      }

      if (answer.isAnswerFinish && answer.fragrances.length === 0) {
        this.setState({ requiredFragrance: true });
        hasError = true;
      }

      if (answer.isAnswerFinish === false && !answer.nextQuizQuestionId) {
        this.setState({ requiredNextQuestion: true });
        hasError = true;
      }

      if (hasError) {
        return;
      }

    if (answerSelectedIndex !== null) {
      question.answers[answerSelectedIndex] = answer;
    } else {
      question.answers.push(answer);
    }

    this.setState({
      ...this.state,
      question: { ...question },
      answer: { ...initialAnswer },
      answerSelectedIndex: null,
      requiredAnswers: false,
      requiredQuestion: false,
      requiredAnswer: false,
      requiredNextQuestion: false,
      requiredFragrance: false
    });
  }

  formatFragrances(fragrances) {
    let result = '';
    fragrances.forEach(e => result += e.label + ', ');

    if (result.length > 2) {
      return result.substr(0, result.length - 2);
    }
    return result;
  }

  formatAnswers(answers) {
    let result = [];

    if(answers){
      result = answers.map((e, i) => (<p key={i}>{e.answer?.label}</p>));
    }

    return result;
  }

  clearAnswer(answer) {
    const { question } = this.state;

    const newAnswers = question.answers.filter(e => e !== answer);
    const newQuestion = { ...question, answers: newAnswers };
    this.setState({ question: newQuestion });
  }

  editAnswer(answer, index) {
    const edit = { ...answer };
    this.setState({ answer: edit, answerSelectedIndex: index });
  }

  async onConfirmDelete(quizQuestionId){
    this.setState({loading:true});
    await this.questionApi.delete(quizQuestionId);
    await this.getQuiz(this.state.quizId);
    this.setState({ confirmDelete: false });
    this.setState({loading:false});
  }

  onEdit(obj){
    const editAnswers = obj.answers?.map(item => ({
      quizQuestionAnswerId: item.quizQuestionAnswerId,
      answerId: item.answerId,
      desc: item.answer?.label,
      description: item.answer?.description,
      isAnswerFinish: item.nextQuestionId !== null && item.undefined ? true : false,
      nextQuizQuestionId: item.nextQuestionId,
      nextQuizQuestion: item.nextQuestionId && {
          label: item.nextQuestion?.question?.quest,
          value: item.nextQuestionId
      },
      fragrances: item.fragranceOptions?.map(option => ({
        label: option.fragrance?.name,
        value: option.fragranceId
      }))
    }));

    const editQuestion = {
      quizQuestionId: obj.quizQuestionId,
      questionId: obj.questionId,
      quest: obj.question?.quest,
      answers: editAnswers
    }

    this.setState({question: {...editQuestion}});
  }

  handleTreeOnChange = treeData => {
    this.setState({ treeData });
  };

  canDragNode = (node, nextParentNode) => {
    let can = true;
    let nextType = nextParentNode ? nextParentNode.nodeType : null;

    if (node.nodeType === 'answer') {
      // nodes do tipo answer só podem ser filhos de question
      if (nextType !== 'question')
        can = false;
    } else if (node.nodeType === 'question') {
      // nodes do tipo question só podem ser filhos de answer
      if (nextType && nextType !== 'answer')
        can = false;
    } else if (node.nodeType === 'fragrance') {
      // nodes do tipo answer só podem ser filhos de answer
      if (nextType !== 'answer')
        can = false;
    }

    return can;
  }

  handleMoveNode = async (treeData, node, nextParentNode) => {
    if (this.canDragNode(node, nextParentNode)) {
      switch (node.nodeType) {
        case "fragrance":
          try {
            const newQuizQuestionAnswerId = nextParentNode.quizQuestionAnswerId;
            const fragranceOptionId = node.fragranceOptionId;

            this.setState({ loading: true });

            const reqBase = { method: 'PUT', url: "updateTree" };
            await this.api.makeHttpRequest({
              ...reqBase,
              data: {
                fragranceOptionId,
                newQuizQuestionAnswerId,
                nodeType: 'fragrance'
              }
            });

            Swal.fire({
              title: translate(this.props.i18n.lang).defaultMessages?.success,
              text: "Tree updated successfuly",
              icon: 'success',
              confirmButtonText: 'OK'
            });
          } catch (error) {
            Swal.fire({
              title: translate(this.props.i18n.lang).defaultMessages?.error,
              text: "Error",
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }

          this.setState({ loading: false });
          break;
        case "question":
          try {
            const quizQuestionAnswerId = nextParentNode.quizQuestionAnswerId;
            const nextQuestionId = node.quizQuestionId;

            this.setState({ loading: true });

            const reqBase = { method: 'PUT', url: "updateTree" };
            await this.api.makeHttpRequest({
              ...reqBase,
              data: {
                quizQuestionAnswerId,
                nextQuestionId,
                nodeType: 'question'
              }
            });

            Swal.fire({
              title: translate(this.props.i18n.lang).defaultMessages?.success,
              text: "Tree updated successfuly",
              icon: 'success',
              confirmButtonText: 'OK'
            });
          } catch (error) {
            Swal.fire({
              title: translate(this.props.i18n.lang).defaultMessages?.error,
              text: "Error",
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }

          this.setState({ loading: false });

          break;
        case "answer":
          try {
            const newQuizQuestionId = nextParentNode.quizQuestionId;
            const quizQuestionAnswerId = node.quizQuestionAnswerId;

            this.setState({ loading: true });

            const reqBase = { method: 'PUT', url: "updateTree" };
            await this.api.makeHttpRequest({
              ...reqBase,
              data: {
                newQuizQuestionId,
                quizQuestionAnswerId,
                nodeType: 'answer'
              }
            });

            Swal.fire({
              title: translate(this.props.i18n.lang).defaultMessages?.success,
              text: "Tree updated successfuly",
              icon: 'success',
              confirmButtonText: 'OK'
            });
          } catch (error) {
            Swal.fire({
              title: translate(this.props.i18n.lang).defaultMessages?.error,
              text: "Error",
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }

          this.setState({ loading: false });
          break;
        default:
      }

      return true;
    } else {
      Swal.fire({
        title: translate(this.props.i18n.lang).defaultMessages?.error,
        text: "Action does not permitted",
        icon: 'error'
      });

      setTimeout(() => {
        this.props.history.go();
      }, 2000);
    }

    return false;
  }

  async genericPut(endpoint, msg){
    try {
      const { quizId } = this.state;
      const reqBase = { method: 'PUT', url: endpoint+'/'+quizId };

      this.setState({ loading: true });

      await this.api.makeHttpRequest({
        ...reqBase
      });

      await this.getQuiz(quizId);
      Swal.fire({
        title: translate(this.props.i18n.lang).defaultMessages?.success,
        text: msg,
        icon: 'success',
        cancelButtonText: translate(this.props.i18n.lang).buttons?.cancel,
      });
    } catch (e) {
      this.setState({ loading: false });
      Swal.fire(
        'ERROR',
        e.response && e.response.status === 400
          ? e.response.data
          : this.translate.screens.quiz.errors.createQuestion,
        'error'
      );
    }
  }

  async validateQuiz(){
    await this.genericPut('validate', this.translate.screens.quiz.messages?.validated);
  }

  async publishQuiz(){
    await this.genericPut('publish', this.translate.screens.quiz.messages?.published);
  }

  toggleConfirmDialog(state) {
    this.setState({ confirmDelete: state });
  }

  render() {
    window.setPageTitle(`${this.translate.screens.quiz.pageTitle.edit} - Admin`);

    const {
      quizName,
      campaignName,
      language,
      questions,
      question,
      answer,
      collection,
      answerSelectedIndex,
      requiredQuestion,
      requiredAnswers,
      requiredAnswer,
      requiredNextQuestion,
      requiredFragrance,
      validatedAt,
      publishedAt
    } = this.state;

    const fragrancesOptions = collection
    .map(e => ({ label: e.fragrance?.name, value: e.fragrance?.fragranceId }))
    // eslint-disable-next-line
    .filter(e => {
      let found = false;
      for (var i = 0; i < answer.fragrances.length; i++) {
        if (answer.fragrances[i].label === e.label && answer.fragrances[i].value === e.value) {
          found = true;
          break;
        }
      }
      if (!found) return e;
    });

    const questionOptions = questions.map(e => ({ value: e.quizQuestionId, label: e.question?.quest }));

    const headRows = [
      { label: this.props.translate.screens.quiz.list.actions },
      { column: 'Question', label: this.props.translate.screens.quiz.labels.question },
      { column: 'Answers', label: this.props.translate.screens.quiz.labels.answer },
      { column: 'CreatedAt', label: this.props.translate.screens.quiz.list.created },
      { column: 'UpdatedAt', label: this.props.translate.screens.quiz.list.updated }
    ];

    const formatRow = r => (
      <TableRow
        hover
        tabIndex={-1}
        key={r.quizQuestionId}
      >
        <TableCell>
          <CrudActions
            actions={['edit', 'delete']}
            module='question'
            //onConfirmChangeStatus={this.onConfirmChangeStatus}
            onConfirmDelete={this.onConfirmDelete}
            onEdit={this.onEdit}
            id={r.quizQuestionId}
            obj={r}
          />
        </TableCell>
        <TableCell scope="row">
          {r.question?.quest}
        </TableCell>
        <TableCell scope="row">
          {this.formatAnswers(r.answers)}
        </TableCell>
        <TableCell scope="row">
          {moment(r.createdAt).format('DD/MM/YYYY HH:mm')}
        </TableCell>
        <TableCell scope="row">
          {moment(r.updatedAt).format('DD/MM/YYYY HH:mm')}
        </TableCell>
      </TableRow>
    );

    return (
      <>
      <ConfirmDeleteDialog
        open={this.state.confirmDelete}
        closeDialog={() => this.toggleConfirmDialog(false)}
        confirm={() => this.onConfirmDelete(this.state.id)}
      />
      <Form>
        <Loading isLoading={this.state.loading} />
        <Card className='mt-3'>
          <Card.Header>
          {this.props.translate.screens.quiz.labels.principal}
          </Card.Header>
          <Card.Body>
            {/* row 1 */}
            <Form.Row>
              {/* Nome */}
              <Form.Group as={Col} lg='3' xs='12'>
                <Form.Label>
                  {this.translate.screens.quiz.labels.name} *
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete='off'
                  name='quizName'
                  placeholder={this.translate.screens.quiz.placeholders.name}
                  maxLength='100'
                  value={quizName}
                  isInvalid={quizName && !IsValidName(quizName)}
                  onChange={this.handleChange}
                  required
                  disabled
                />
              </Form.Group>

              {/* Campanha */}
              <Form.Group as={Col} lg='6' xs='12'>
                <Form.Label>
                  {this.translate.screens.quiz.labels.campaign} *
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete='off'
                  name='campaignName'
                  placeholder={this.translate.screens.quiz.placeholders.campaign}
                  maxLength='100'
                  value={campaignName}
                  required
                  disabled
                />
              </Form.Group>

              {/* Nome */}
              <Form.Group as={Col} lg='3' xs='12'>
                <Form.Label>
                  {this.props.translate.screens.quiz.labels.language}
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete='off'
                  name='name'
                  maxLength='10'
                  value={language}
                  disabled
                />
              </Form.Group>
            </Form.Row>
          </Card.Body>
        </Card>
        <Card className='mt-3'>
            <Card.Header>
            {this.props.translate.screens.quiz.labels.questionarie}
            </Card.Header>
            <Card.Body>
              <Form.Group as={Col} lg='12' xs='12' className='mt-3'>
                <Form.Row>
                  <Form.Group as={Col} lg='12' xs='12' className='mb-5'>
                    <Form.Row>
                      <Form.Group as={Col} lg='12' xs='12' className='mb-1'>
                        <Form.Label>{this.props.translate.screens.quiz.labels.question}</Form.Label>
                        <SelectSearchComponent
                          value={question.questionId && {
                            id: question.questionId,
                            value: question.questionId,
                            label: question.quest
                          }}
                          required={requiredQuestion ? { status: 'invalid' } : null}
                          resetInput={question.quest === ''}
                          handleChange={this.handleQuestion}
                          name="question"
                          className="kt-width-full"
                          label={this.translate.screens.quiz.placeholders?.question}
                          url={`/question/by-name?language=${language}&str=`}
                          convertObject={obj => ({
                            id: obj.questionId,
                            value: obj.questionId,
                            label: obj.quest
                          })}
                          createLabelText={this.translate.screens.quiz.placeholders?.newQuestion}
                          newOption={true}
                        />
                        {requiredQuestion ?
                          <Form.Label style={{ color: '#FF0000' }}>{this.translate.screens.quiz.errors?.questionRequired}</Form.Label>
                          : null}
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} lg='4' xs='12' className='mb-1'>
                        <Form.Label>{this.props.translate.screens.quiz.labels.answer}</Form.Label>
                        <SelectSearchComponent
                          resetInput={answer.desc === ''}
                          handleChange={this.handleAnswer}
                          name="answer"
                          className="kt-width-full"
                          label={this.translate.screens.quiz.placeholders?.answer}
                          url={`/answer/by-name?language=${language}&str=`}
                          convertObject={obj => ({
                            id: obj.answerId,
                            value: obj.answerId,
                            label: obj.label,
                            description: obj?.description
                          })}
                          newOption={true}
                          createLabelText={this.translate.screens.quiz.placeholders?.newAnswer}
                        />
                        {requiredAnswer ?
                          <Form.Label style={{ color: '#FF0000' }}>{this.translate.screens.quiz.errors?.answerRequired}</Form.Label>
                          : null}
                      </Form.Group>

                      <Form.Group as={Col} lg='8' xs='12' className='mb-1'>
                          <Form.Label>{this.translate.screens.quiz.labels?.description}</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={this.translate.screens.quiz.placeholders?.description}
                            value={this.state.answer.description}
                            name="description"
                            onChange={this.handleChangeAnswerDesc}
                          />
                      </Form.Group>

                      <Form.Group as={Col} lg='4' xs='12' className='mb-1'>
                        <Form.Label>{this.props.translate.screens.quiz.labels.destiny}</Form.Label>
                        <RadioGroup row aria-label="filtro" style={{flexWrap: "nowrap"}}name="radioAnswer" value={answer.isAnswerFinish} onChange={this.handleRadio}>
                          <FormControlLabel value="false" control={<BrownRadio />} label={this.props.translate.screens.quiz.labels.next} checked={!answer.isAnswerFinish} />
                          <FormControlLabel value="true" control={<BrownRadio />} label={this.props.translate.screens.quiz.labels.fragrances} checked={answer.isAnswerFinish} />
                        </RadioGroup>
                      </Form.Group>

                      {
                        answer.isAnswerFinish ?
                          <Form.Group as={Col} lg='6' xs='12' className='mb-1'>
                            <Form.Label>{this.props.translate.screens.quiz.labels.fragrances}</Form.Label>
                            <Select
                              isMulti
                              placeholder={this.translate.screens.quiz.placeholders?.fragrances}
                              noOptionsMessage={obj => obj?.inputValue ? obj?.inputValue : this.props.translate.screens.quiz.labels?.noFragranceOption}
                              value={answer.fragrances}
                              name="fragrancesSelected"
                              options={fragrancesOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              onChange={this.handleSelectFragranceAnswer}
                            />
                            {answer.isAnswerFinish && requiredFragrance ?
                              <Form.Label style={{ color: '#FF0000' }}>{this.translate.screens.quiz.errors?.fragranceRequired}</Form.Label>
                              : null}
                          </Form.Group>
                          :
                          <Form.Group as={Col} lg='6' xs='12' className='mb-1'>
                            <Form.Label>{this.props.translate.screens.quiz.labels.next}</Form.Label>
                            <Select
                              value={answer.nextQuizQuestion}
                              placeholder={this.translate.screens.quiz.placeholders?.next}
                              noOptionsMessage={obj => obj?.inputValue ? obj?.inputValue : this.translate.screens.quiz.errors?.noQuestionOption}
                              name="questionsToLink"
                              options={questionOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              onChange={this.handleSelectNextQuestion}
                            />
                            {!answer.isAnswerFinish && requiredNextQuestion ?
                              <Form.Label style={{ color: '#FF0000' }}>{this.translate.screens.quiz.errors?.nextRequired}</Form.Label>
                              : null}
                          </Form.Group>
                      }

                      <Form.Group as={Col} lg='2' xs='4' className='mb-0 pt-2'>
                        <Button variant="primary"
                          onClick={this.addAnswer}
                          className='mt-4'>
                          {answerSelectedIndex !== null
                              ?
                                this.translate.screens.quiz.labels?.updateAnswer
                              :
                                this.translate.screens.quiz.labels?.addAnswer
                              }
                        </Button>
                      </Form.Group>
                    </Form.Row>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  {requiredAnswers ?
                    <Form.Label style={{ color: '#FF0000' }}>{this.translate.screens.quiz.errors?.answersRequired}</Form.Label>
                    : null}
                  <Table striped bordered responsive>
                    <thead className='table-dark'>
                      <tr className='text-uppercase'>
                        <th className='font-weight-bold' width='25%'>{this.props.translate.screens.quiz?.labels?.answer}</th>
                        <th className='font-weight-bold' width='20%'>{this.props.translate.screens.quiz?.labels?.description}</th>
                        <th className='font-weight-bold' width='20%'>{this.props.translate.screens.quiz?.labels?.fragrances}</th>
                        <th className='font-weight-bold' width='25%'>{this.props.translate.screens.quiz?.labels?.next}</th>
                        <th className='font-weight-bold' width='10%'></th>
                      </tr>
                    </thead>
                    <tbody>
                      {question.answers.length
                        ? (
                          question.answers
                            .map((a, i) => (
                              <tr key={'answer-' + i}>
                                <td>
                                  {a.desc}
                                </td>
                                <td>
                                  {a.description}
                                </td>
                                <td>
                                  {this.formatFragrances(a.fragrances)}
                                </td>
                                <td>
                                  {a.nextQuizQuestion?.label}
                                </td>
                                <td>
                                  <IconButton
                                    size="small"
                                    title={this.translate.screens.quiz.labels?.editAnswer}
                                    onClick={() => this.editAnswer(a, i)}>
                                    <Edit fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    title={this.translate.screens.quiz.labels?.deleteAnswer}
                                    onClick={() => this.clearAnswer(a)}>
                                    <Delete fontSize="small" />
                                  </IconButton>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr className='text-center'>
                            <td colSpan={5}>{this.translate.screens.quiz.labels?.noQuestions}</td>
                          </tr>
                        )}
                    </tbody>
                  </Table>
                  <Form.Group as={Col} lg='12' xs='12' className='mt-3 pt-2'>
                    <div className='text-left'>
                      <Button variant="primary"
                        onClick={this.createQuestion}
                        className='mr-3'>
                        {question.quizQuestionId
                          ?
                            this.translate.screens.quiz.labels?.updateQuestion
                          :
                            this.translate.screens.quiz.labels?.saveQuestion
                        }
                      </Button>

                      <Button variant="secondary"
                        onClick={this.onCleanForm}
                        className='mr-3'>
                        <FormattedMessage id="BUTTON_CLEAN_TEXT" />
                      </Button>

                      <Link to={`/admin/quiz`} className='mr-3'>
                        <Button variant="secondary" type="button">
                          <FormattedMessage id="BUTTON_CANCEL_TEXT" />
                        </Button>
                      </Link>

                      <Button variant="primary"
                        onClick={this.validateQuiz}
                        className='mr-3'
                        disabled={validatedAt !== null || questions.length === 0}>
                        {this.translate.screens.quiz.labels?.validate}
                      </Button>
                      <Button variant="success"
                        onClick={this.publishQuiz}
                        className='mr-3'
                        disabled={validatedAt === null || publishedAt !== null}>
                        {this.translate.screens.quiz.labels?.publish}
                      </Button>
                    </div>
                  </Form.Group>
                </Form.Row>
              </Form.Group>

              <DatatableStandalone
                headRows={headRows}
                formatRow={formatRow}
                rows={questions}
              />
            </Card.Body>
          </Card>
      </Form >
      </>
    )
  }
}

const mapStoreToProps = store => ({
  i18n: store.i18n
});

const connected = connect(mapStoreToProps, null)(QuizUpdate);

export default withRouter(
  withFormValidation(connected, initialState)
);
